<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true" [loading]="(activityLoading$ | async) || (forking$ | async)">
  <div class="flex-row items-center" left>
    @if (!(isReader$ | async) && !(approveIsTranslate$ | async)) {
    <button mat-icon-button (click)="approveActivity()" [matTooltip]="'activity.preview.approve.tooltip' | translate">
      <mat-icon>done</mat-icon>
    </button>
    @if ((hasOUWritePermission$ | async) && (activityDetails$ | async)?.replace_activity_id === null) {
    <button mat-icon-button type="button" (click)="forkActivity()" [matTooltip]="'activity.preview.copy.create.tooltip' | translate">
      <mat-icon class="icon-btn">call_split</mat-icon>
    </button>
    } } @if (!(isReader$ | async) && (approveIsTranslate$ | async)) {
    <button mat-icon-button (click)="forkActivity()" [matTooltip]="'activity.preview.translate.tooltip' | translate">
      <mat-icon>translate</mat-icon>
    </button>
    }
  </div>
  <div right>
    @if ( !(isReader$ | async) && ( activityDetails$ | async )?.replace_activity_id === null && !(isRevokedInNodePath$ | async) ) {
    <button mat-icon-button type="button" (click)="excludeActivity()" [matTooltip]="'activity.exclude.tooltip' | translate">
      <mat-icon>remove_circle</mat-icon>
    </button>
    }
  </div>
</app-doenkids-menu-bar>
<div content>
  <app-split-page
  [activeTab]="0"
  [leftLabel]="'activity.preview.tab.details' | translate"
  [rightLabel]="'activity.preview.tab.preview' | translate"
  (selectedTabChange)="renderPdf()"
>
  <ng-template #left>
    <div class="sections-container">
      @if (activityDetails$ | async; as activity) {
      <div class="details">
        <div class="main-details flex-col md-flex-row-reverse justify-between items-start">
          <app-doenkids-image [maxHeight]="150" [maxWidth]="150" [mediaItem]="(activityDetails$ | async)?.media_uuid"> </app-doenkids-image>
          <div class="title flex-col">
            <h1 [style.color]="headingColor">
              {{ activity.name !== '' ? activity.name : ('generic.new' | translate) }}
            </h1>
            <h2 [style.color]="subheadingColor">{{ activity.subtitle }}</h2>
            @if (activity.summary) {
            <p class="summary">
              <i>{{ activity.summary }}</i>
            </p>
            }
          </div>
        </div>
      </div>
      } @for (section of ( mediaSections$ | async ); track section.id) {
      <div>
        @if (section.data?.title) {
        <h2 [style.color]="headingColor">{{ section.data?.title }}</h2>
        } @if (section.data?.subtitle) {
        <h2 [style.color]="subheadingColor">{{ section.data?.subtitle }}</h2>
        }

        <!-- Videos -->
        @for (safeUrl of section.data?.video; track $index) { @if (safeUrl && safeUrl.length > 1) {
        <div class="video-cards animated fadeIn">
          @if (safeUrl) {
          <iframe [src]="safeUrl | safe : 'resourceUrl'"></iframe>
          }
        </div>
        } }
      </div>
      } @for (section of ( notMediaSections$ | async ); track section.id) {
      <div>
        @if (section.data?.title) {
        <h2 [style.color]="headingColor">{{ section.data?.title }}</h2>
        } @if (section.data?.subtitle) {
        <h2 [style.color]="subheadingColor">{{ section.data?.subtitle }}</h2>
        } @switch (section.type_id) { @default { @if (section.data?.content) {
        <div [innerHTML]="section.data?.content" class="ql-editor"></div>
        } } @case (ESectionType.GLOSSARY) {
        {{ section.data?.terms }}
        @for (term of section.data?.term; track term.name) {
        <div>
          <b>{{ term.name }}</b
          ><span>{{ term.description }}</span>
        </div>
        } } @case (ESectionType.SOURCES) { @for (source of section.data?.source; track $index) {
        <div>
          <a [href]="source" target="_blank">{{ source }}</a>
        </div>
        } } @case (ESectionType.MEDIA) {
        <div class="media-container">
          @for (media of section.data?.media; track media.uuid) { @if (media?.uuid) {
          <mat-card appearance="outlined" class="media-item">
            <app-doenkids-image [maxHeight]="150" [maxWidth]="150" [mediaItem]="media?.uuid" class="media-image"> </app-doenkids-image>
            @if (media.description) {
              <br />
              <i>{{ media.description }}</i>
            }
          </mat-card>
          } }
        </div>
        } }
      </div>
      }

      <!-- Attatchements in metaData card-->
      <div class="attachments">
        @if (( activityAttachments$ | async ).length > 0) {
        <h2>{{ 'generic.attachments' | translate }}</h2>
        }
        <div class="attachment-container">
          @for (attachment of activityAttachments$ | async; track attachment.filename) {
          <div class="attachment">
            <div class="attachment-content-container">
              <mat-icon class="attachment-icon">insert_drive_file</mat-icon>
              <a class="attachment-link" (click)="openAttachment(attachment)">
                <span>{{ attachment['filename'] }}</span>
              </a>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #right>
    <div class="pdf-container">
      <app-pdf-viewer
        [pdfSrc]="pdf$ | async"
        [loading]="pdfLoading"
        (pdfLoaded)="onPdfLoadedEvent()"
      ></app-pdf-viewer>
    </div>
  </ng-template>
</app-split-page>
</div>
</app-page-content>
